import { BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import { RecoilRoot } from "recoil";
import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { VersionBar, VersionBarEnvironment } from "shared-ui-component";
import "shared-ui-component/dist/index.css";

export function App() {
  const auth = useAuth();

  const labels: { [key: string]: string } = {
    dev: "DEV",
    test: "TEST",
    uat: "UAT",
    prod: "PROD",
  };
  const version = String(process.env.REACT_APP_RELEASE_VERSION || "");
  const env: VersionBarEnvironment =
    (process.env.REACT_APP_ENV as VersionBarEnvironment) || "prod";

  const [buildNumber, setBuildNumber] = useState("");

  useEffect(() => {
    const isLoggedOutPath = window.location.pathname === "/logged-out";

    if (!isLoggedOutPath && !auth.isLoading && !auth.isAuthenticated) {
      if (window.location.search) {
        // Clear query parameters before login
        window.location.href = window.location.origin;
      } else {
        auth.clearStaleState();
        auth.signinRedirect(); // Login
      }
    } else if (auth.isAuthenticated) {
      localStorage.setItem("accessToken", auth.user?.access_token ?? "");

      // Check if the page has already been reloaded
      if (!sessionStorage.getItem("hasReloaded")) {
        sessionStorage.setItem("hasReloaded", "true"); // Mark reload as done
        window.location.replace(
          window.location.origin + window.location.pathname
        );
      }
    }

    fetch("/version.json")
      .then((res) => res.json())
      .then((data) => {
        if (data.version) {
          setBuildNumber(`(${data.version})`);
        }
      })
      .catch(() => setBuildNumber(""));
  }, [auth]);

  return (
    <>
      {!auth.isLoading && env !== "prod" && (
        <VersionBar
          environment={env}
          environmentLabel={labels[env]}
          versionLabel={version}
          buildLabel={buildNumber}
        ></VersionBar>
      )}
      <RecoilRoot>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </RecoilRoot>
    </>
  );
}

export default App;
